import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { DigitalVaultCategoriesAdministrationView } from "../../views";
import { CategoryService, LocalStorageService } from "../../../services";
import { DialogSystemGLPure } from "../../pures";

const DigitalVaultCategoriesAdministrationAction = (props) => {
    const [categoriesFiltered, setCategoriesFiltered] = useState([])
    const [categories, setCategories] = useState([])
    const [filterOptions, setFilterOptions] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const categoryService = new CategoryService(process.env.REACT_APP_MIFIRMA_API)
    const localStorageService = new LocalStorageService();
    const token = localStorageService.getLocalStorageItem("token").idToken;
    const [loadingRequesting, toggleLoadingRequesting] = useState(false)
    const [errorRequesting, toggleErrorRequesting] = useState(false)
    const [completedRequesting, toggleCompletedRequesting] = useState(false)
    const [warningRequesting, toggleWarningRequesting] = useState(false)
    const [message, setMessage] = useState("")
    const [defaultCategories, setDefaultCategories] = useState([])
    const [subCategories, setSubcategories] = useState([])

    const getCategories = async () => {
        setIsLoading(true)
        let categories
        try {
            categories = await categoryService.getCompaniesWithCategories(token)
            if (categories.statusCode !== 200) throw new Error("Ha ocurrido un error para obtener las categorías");
            let filterOptions = []

            for (let i = 0; i < categories.data.categoriesCompanies.length; i++) {
                categories.data.categoriesCompanies[i].categories.map((item) => {
                    if (item.defined === "Default") {
                        item.defined = props.t("digitalVaultCategoriesAdministration.main.grid.default")
                    } else {
                        item.defined = props.t("digitalVaultCategoriesAdministration.main.grid.custom")
                    }
                    switch (item.levelUser) {
                        case "13":
                        case "16":
                        case "17":
                        case "18":
                            item.levelUser = Number(item.levelUser)
                            break
                        default:
                            item.levelUser = ""
                            break;
                    }
                    return item
                })
            }

            for (let i = 0; i < categories.data.categoriesCompanies.length; i++) {
                if(categories.data.categoriesCompanies[i].company.companyName === 'Todas las empresas') categories.data.categoriesCompanies[i].company.companyName = props.t("digitalVaultCategoriesAdministration.all.companies")
                filterOptions.push({ name: categories.data.categoriesCompanies[i].company.companyName, companyId: categories.data.categoriesCompanies[i].company.id })
            }
            setIsLoading(false)
            setFilterOptions(filterOptions)
            setCategories(categories.data.categoriesCompanies)
            setDefaultCategories(categories.data.categoriesDefault)
            setCategoriesFiltered(categories.data.categoriesCompanies[0].categories)
        } catch (e) {
            console.log(e.message)
            props.history.replace("/digital-vault/home")
        }
    }

    const updateCategories = async () => {
        setIsLoading(true)
        let categories
        try {
            categories = await categoryService.getCompaniesWithCategories(token)
            if (categories.statusCode !== 200) throw new Error("Ha ocurrido un error para obtener las categorías");

            let filterOptions = []

            for (let i = 0; i < categories.data.categoriesCompanies.length; i++) {
                categories.data.categoriesCompanies[i].categories.map((item) => {
                    if (item.defined === "Default") {
                        item.defined = props.t("digitalVaultCategoriesAdministration.main.grid.default")
                    } else {
                        item.defined = props.t("digitalVaultCategoriesAdministration.main.grid.custom")
                    }
                    switch (item.levelUser) {
                        case "13":
                        case "16":
                        case "17":
                        case "18":
                            item.levelUser = Number(item.levelUser)
                            break
                        default:
                            item.levelUser = ""
                            break;
                    }
                    return item
                })
            }
            for (let i = 0; i < categories.data.categoriesCompanies.length; i++) {
                filterOptions.push({ name: categories.data.categoriesCompanies[i].company.companyName, companyId: categories.data.categoriesCompanies[i].company.id })
            }
            setIsLoading(false)
            setFilterOptions(filterOptions)
            setCategories(categories.data.categoriesCompanies)
            setCategoriesFiltered(categories.data.categoriesCompanies[0].categories)
        } catch (e) {
            console.log(e.message)
            props.history.replace("/digital-vault/categories")
        }
    }

    const getSubCategories = async (companyId, categoryId) => {
        setIsLoading(true)
        let subcategories
        try {
            !companyId ? subcategories = await categoryService.getSubcategoriesByCategory(categoryId, "", token) : subcategories = await categoryService.getSubcategoriesByCategory(categoryId, companyId, token)
            if (subcategories.statusCode !== 200) throw new Error("Ocurrió un error!")

            let subcats = []
            if (subcategories.data.length > 0) {
                subcats = subcategories.data.map(item => {
                    return item
                })
                subcats.map((item) => {
                    if (item.defined === "Default") {
                        item.defined = props.t("digitalVaultCategoriesAdministration.main.grid.default")
                    } else {
                        item.defined = props.t("digitalVaultCategoriesAdministration.main.grid.custom")
                    }
                    switch (item.levelUser) {
                        case "13":
                        case "16":
                        case "17":
                        case "18":
                            item.levelUser = Number(item.levelUser)
                            break
                        default:
                            item.levelUser = ""
                            break;
                    }
                    return item
                })
            }
            setSubcategories(subcats)
            setIsLoading(false)
        } catch (e) {
            console.log(e.message)
            props.history.replace("/digital-vault/home")
        }
    }

    const updateSubcategories = async (companyId, categoryId) => {
        setIsLoading(true)
        let subcategories
        try {
            !companyId ? subcategories = await categoryService.getSubcategoriesByCategory(categoryId, "", token) : subcategories = await categoryService.getSubcategoriesByCategory(categoryId, companyId, token)
            if (subcategories.statusCode !== 200) throw new Error("Ocurrió un error!")

            const subcats = subcategories.data.map(item => {
                return item
            })
            subcats.map(item => {
                if (item.defined === "Default") {
                    item.defined = props.t("digitalVaultCategoriesAdministration.main.grid.default")
                } else {
                    item.defined = props.t("digitalVaultCategoriesAdministration.main.grid.custom")
                }
                switch (item.levelUser) {
                    case "13":
                    case "16":
                    case "17":
                    case "18":
                        item.levelUser = Number(item.levelUser)
                        break
                    default:
                        item.levelUser = ""
                        break;
                }
                return item
            })
            setSubcategories(subcats)
            setIsLoading(false)
        } catch (e) {
            console.log(e.message)
            props.history.replace("/digital-vault/home")
        }
    }



    useEffect(() => {
        getCategories(categories)
    }, [])

    return (
        <>
            <DialogSystemGLPure
                showLoadingRequesting={loadingRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}
                showCompletedRequesting={completedRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}
                showErrorRequesting={errorRequesting}
                toggleErrorRequesting={toggleErrorRequesting}
                showWarningRequesting={warningRequesting}
                toggleWarningRequesting={toggleWarningRequesting}
                message={message}
                messageComplete={message}
            />
            <DigitalVaultCategoriesAdministrationView
                subCategories={subCategories}
                setMessage={setMessage}
                updateSubcategories={updateSubcategories}
                getSubCategories={getSubCategories}
                defaultCategories={defaultCategories}
                isLoading={isLoading}
                categories={categories}
                categoriesFiltered={categoriesFiltered}
                filterOptions={filterOptions}
                updateCategories={updateCategories}
                showLoadingRequesting={loadingRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}
                showCompletedRequesting={completedRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}
                showErrorRequesting={errorRequesting}
                toggleErrorRequesting={toggleErrorRequesting}
                showWarningRequesting={warningRequesting}
                toggleWarningRequesting={toggleWarningRequesting}
            />
        </>
    )

}

export default withRouter(withTranslation()(DigitalVaultCategoriesAdministrationAction)); 